import Actions                   from 'Redux/Actions';
import { EventTicketRepository } from 'Domain/Repositories';
import { ofType }                from 'redux-observable';
import { from, EMPTY }           from 'rxjs';
import { mergeMap }              from 'rxjs/operators';
import { TEpic }                 from 'Redux/Config';

export const findEventTicketEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventTicketRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        EventTicketRepository.findById(id)
          .then((eventTicket) => Actions.findEventTicketSuccess({ eventTicket }))
          .catch(error => Actions.findEventTicketFailure({ error })),
      );
    }),
  );
};
